import {IMapper} from "../i-mapper";
import {IApp, IApplicationSettingsInstalledAppsField} from "@zaeper/angular-application-store-lib";
import {InputSelection, ISelectionOption} from "@zaeper/angular-dashboard-view-lib";
import {FormControl, FormGroup} from "@angular/forms";

export class ApplicationSettingsInstalledAppsFieldMapper implements Partial<IMapper<IApplicationSettingsInstalledAppsField, InputSelection>> {
  constructor(private readonly _apps: IApp[], private readonly _formGroup: FormGroup) {
  }

  from(applicationSettingsInstalledAppsField: IApplicationSettingsInstalledAppsField): InputSelection {
    if (applicationSettingsInstalledAppsField.multiple) {
      console.warn('InstalledApps field requested multiple selection, but InputSelection only supports single-select. Falling back to single-select. Phase 3 needs a true multi-select component.');
    }

    const defaultValue: string | null = this._getDefaultValue(applicationSettingsInstalledAppsField.defaultValue, this._apps);
    const selections: ISelectionOption[] = this._getSelections(this._apps);

    const formControl: FormControl<string | null> = new FormControl(defaultValue);

    this._formGroup.setControl(applicationSettingsInstalledAppsField.id, formControl);

    return new InputSelection({
      formControlEntry: {
        formControl: formControl, key: applicationSettingsInstalledAppsField.id
      },
      title: applicationSettingsInstalledAppsField.label.de,
      inputId: applicationSettingsInstalledAppsField.id,
      required: applicationSettingsInstalledAppsField.required ?? false,
      placeholder: applicationSettingsInstalledAppsField.placeholder?.de,
      selections: selections
      // TODO Phase 3: honor `multiple`, `description`, `compact`
    });
  }

  private _getDefaultValue(defaultValue: ReadonlyArray<string> | undefined, apps: IApp[]): string | null {
    if (!defaultValue || defaultValue.length === 0) {
      return null;
    }
    const preferred: string = defaultValue[0];
    return apps.some((app: IApp): boolean => app.id === preferred) ? preferred : null;
  }

  private _getSelections(apps: IApp[]): ISelectionOption[] {
    return apps.map((app: IApp): ISelectionOption => ({
      title: app.name, value: app.id
    }));
  }
}
